import { useSyncExternalStore } from 'react';


function subscribe(callback:any) {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
}


export function useWindowWidth() {
  return useSyncExternalStore(
    subscribe,
    () => window.innerWidth,
    () => 0
  );
}